export default __webpack_public_path__ + "static/media/blog-1.5798fc4e.jpg";